import ReactDOM from 'react-dom';
import { ToastContainer, Slide } from 'react-toastify';

import { memoizedComponent } from 'utils/memoizeComponent';

import './notification.css';

const NotificationContainer = memoizedComponent(() =>
  ReactDOM.createPortal(
    <ToastContainer
      className='toast-container'
      toastClassName='toast-wrapper'
      bodyClassName='toast-body'
      progressClassName=''
      position='top-center'
      stacked
      transition={Slide}
      hideProgressBar
      closeButton={false}
    />,
    document.body,
  ),
);

export default NotificationContainer;
